// 건설업 등록 의무 안내 — 금액으로 판정·경고하지 않고 설정의 등록번호 칸 옆 i 로만 보인다(종이에는 안 나온다).
export const LICENSE_INFO_LABEL = "건설업 등록번호 안내";

export const LICENSE_REQUIRED_HINT =
  "실내건축 등 전문공사는 1건 공사예정금액이 1,500만원 이상이면 건설업 등록이 필요합니다. 고객이 직접 산 자재값도 더하고, 나눠 계약해도 합칩니다. 부가세는 조문에 따로 없어 포함한 총액으로 보는 편이 안전합니다.";

export const LICENSE_REQUIRED_SOURCE = "건설산업기본법 제9조 제1항 단서 · 시행령 제8조 제1항 제2호·제2항";
